/**
 * Sliko pred pošiljanjem pomanjša na najdaljšo stranico {@code najvec} px (JPEG 85 %): manj prenosa s telefona in
 * prostora za dokumente vozila. Žetonov umetne inteligence to ne zmanjša (Gemini šteje sliko po nastavljeni ločljivosti,
 * ne po velikosti datoteke). PDF, majhne slike in slike, ki jih brskalnik ne zna odpreti (npr. HEIC), ostanejo, kot so.
 */
export async function pomanjsaj(f: File, najvec = 2000): Promise<File> {
  if (!f.type.startsWith('image/') || f.type === 'image/heic' || f.type === 'image/heif') {
    return f;
  }
  try {
    const slika = await createImageBitmap(f);
    const k = Math.min(1, najvec / Math.max(slika.width, slika.height));
    if (k === 1 && f.size < 1_500_000) {
      slika.close();
      return f;
    }
    const platno = document.createElement('canvas');
    platno.width = Math.round(slika.width * k);
    platno.height = Math.round(slika.height * k);
    platno.getContext('2d')?.drawImage(slika, 0, 0, platno.width, platno.height);
    slika.close();
    const blob = await new Promise<Blob | null>((r) => platno.toBlob(r, 'image/jpeg', 0.85));
    if (!blob || blob.size >= f.size) {
      return f;
    }
    return new File([blob], f.name.replace(/\.[^.]+$/, '') + '.jpg', { type: 'image/jpeg' });
  } catch {
    return f;
  }
}

/** Vse datoteke (slike pomanjšane, ostale nespremenjene). */
export function pomanjsajVse(datoteke: File[], najvec = 2000): Promise<File[]> {
  return Promise.all(datoteke.map((f) => pomanjsaj(f, najvec)));
}
